export const employee = [
  {
    _id: "012",
    name: "Jenny Wilson",
    description: "ELRN-254264",
    created: "20-02-2025, 06:00PM",
  },
  {
    _id: "013",
    name: "Jenny sf",
    description: "ELRN-254264",
    created: "20-02-2025, 06:00PM",
  },
  {
    _id: "014",
    name: "Jenny dsfefdcx",
    description: "ELRN-254264",
    created: "20-02-2025, 06:00PM",
  },
  {
    _id: "015",
    name: "Jenny fedssfd",
    description: "ELRN-254264",
    created: "20-02-2025, 06:00PM",
  },
];
